<template>
  <div class="flex flex-col space-y-12">
    <Burial
      v-for="index in Object.keys(toUpdate)"
      :key="index"
      :type="type"
      :index="index"
      :value="toUpdate[index]"
      @input="($event) => onUpdateBurial('update', index, $event)"/>
    <Burial
      v-for="index in Object.keys(toCreate)"
      :key="parseInt(index, 10) + toUpdate.length"
      :type="type"
      :index="parseInt(index, 10) + toUpdate.length"
      :value="toCreate[index]"
      @input="($event) => onUpdateBurial('create', index, $event)"/>
    <span
      class="cursor-pointer flex flex-row items-center justify-center"
      v-if="canAddBurial"
      @click="addBurial()">
      <span class="btn-plus w-10 h-10 mr-2"></span>
      <b class="text-15px leading-21px text-primary">
        Добавить захоронение
      </b>
    </span>
  </div>
</template>

<script>
import Burial from '@/pages/Objects/ObjectNew/Components/Burial.vue';

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'single',
    },
    update: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    create: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  components: {
    Burial,
  },
  data() {
    return {
      toUpdate: this.update,
      toCreate: this.create,
    };
  },
  computed: {
    canAddBurial() {
      const update = +this.toUpdate.length;
      const create = +this.toCreate.length;
      if (this.type === 'family') {
        return (update + create) < 10;
      }
      return (update + create) < 1;
    },
  },
  methods: {
    addBurial() {
      if (!this.canAddBurial) return null;
      return this.toCreate.push({
        persons: [
          {
            name: '',
            birthday: '',
            deathday: '',
          },
        ],
        headstone: null,
        pedestal: null,
        flowerGarden: null,
        comment: null,
        photoAttaches: [],
      });
    },
    onUpdateBurial(type, index, event) {
      switch (type) {
        case 'create':
          this.$set(this.toCreate, index, event);
          break;
        case 'update':
          this.$set(this.toUpdate, index, event);
          break;
        default:
      }
    },
  },
  watch: {
    toUpdate: {
      handler(value) {
        this.$emit('update-input', value);
      },
      deep: true,
    },
    toCreate: {
      handler(value) {
        this.$emit('create-input', value);
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      if (!this.toUpdate.length && !this.toCreate.length) {
        this.addBurial();
      }
    });
  },
};
</script>
